import Button from "@mui/material/Button";
import useColors from "../../../../api/hooks/useColors";

const ManagePOCLimitsButton = ({ handleOnClick }) => {
  const colors = useColors();

  return (
    <Button
      variant="outlined"
      sx={{
        backgroundColor: colors.info_lighter,
        textTransform: "none",
        color: colors.common_black,
      }}
      onClick={handleOnClick}
    >
      Manage POC Limits
    </Button>
  );
};

export default ManagePOCLimitsButton;
